// Barrel: 90 x 135
// Beam: 100 x 20
// Crate: 138.6 x 72.8
// Chest: 150 x 90

export default [
    // Pyramid
    {
        focus: [1600, 150, 600],
        entities: [
            { class: "Background", position: [1200, -60, -750], scale: 1, rotation: 0 },
            { class: "Slingshot", position: [300, 200, 0], scale: 1, rotation: 0 },
            { class: "Bubbles", position: [-1000, -275, 0], scale: 1, rotation: 0 },

            { class: "Barrel", position: [1510, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1600, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1690, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1555, 135], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1645, 135], scale: 1, rotation: 0 },

            { class: "Chest", position: [1600, 247.5], scale: 1, rotation: 0 },
        ]
    },

    // Tank // Sideways barrels seem to be off center so the wheel look weird
    // {
    //     focus: [1600, 150, 600],
    //     entities: [
    //         { class: "Background", position: [1200, -60, -750], scale: 1, rotation: 0 },
    //         { class: "Slingshot", position: [300, 200, 0], scale: 1, rotation: 0 },
    //         { class: "Bubbles", position: [-1000, -275, 0], scale: 1, rotation: 0 },

    //         { class: "BarrelSideways", position: [1510, 0], scale: 1, rotation: 0 },
    //         { class: "BarrelSideways", position: [1600, 0], scale: 1, rotation: 0 },
    //         { class: "BarrelSideways", position: [1690, 0], scale: 1, rotation: 0 },
    //         { class: "BarrelSideways", position: [1780, 0], scale: 1, rotation: 0 },
            
    //         { class: "Beam", position: [1600, 65], scale: 2, rotation: 0 },
            
    //         { class: "Chest", position: [1600, 110], scale: 1, rotation: 0 },
    //     ]
    // },

    // Human
    {
        focus: [1600, 150, 600],
        entities: [
            { class: "Background", position: [1200, -60, -750], scale: 1, rotation: 0 },
            { class: "Slingshot", position: [300, 200, 0], scale: 1, rotation: 0 },
            { class: "Bubbles", position: [-1000, -275, 0], scale: 1, rotation: 0 },

            { class: "Barrel", position: [1545, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1545, 135], scale: 1, rotation: 0 },
            
            { class: "Barrel", position: [1655, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1655, 135], scale: 1, rotation: 0 },

            { class: "Crate", position: [1600, 238.9], scale: 1, rotation: 0 },
            // { class: "Crate", position: [1600, 311.7], scale: 1, rotation: 0 },

            { class: "Beam", position: [1600, 275.3], scale: 2, rotation: 0 },

            { class: "Chest", position: [1600, 340.3], scale: 1, rotation: 0 },
        ]
    },

    // Football
    {
        focus: [1600, 150, 600],
        entities: [
            { class: "Background", position: [1200, -60, -750], scale: 1, rotation: 0 },
            { class: "Slingshot", position: [300, 200, 0], scale: 1, rotation: 0 },
            { class: "Bubbles", position: [-1000, -275, 0], scale: 1, rotation: 0 },

            { class: "Barrel", position: [1600, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1600, 135], scale: 1, rotation: 0 },

            { class: "Beam", position: [1600, 222.5], scale: 2, rotation: 0 },

            { class: "Barrel", position: [1510, 330], scale: 1, rotation: 0 },

            { class: "Barrel", position: [1690, 330], scale: 1, rotation: 0 },

            { class: "Chest", position: [1600, 307.5], scale: 1, rotation: 0 },

            { class: "Chest", position: [2000, 0], scale: 1, rotation: 0 },
        ]
    },

    // Office building 2 stories tall
    {
        focus: [1600, 150, 600],
        entities: [
            { class: "Background", position: [1200, -60, -750], scale: 1, rotation: 0 },
            { class: "Slingshot", position: [300, 200, 0], scale: 1, rotation: 0 },
            { class: "Bubbles", position: [-1000, -275, 0], scale: 1, rotation: 0 },

            { class: "Crate", position: [1400, 0], scale: 1, rotation: Math.PI / 2 },
            { class: "Crate", position: [1400, 138.6], scale: 1, rotation: Math.PI / 2 },
            { class: "Chest", position: [1600, 0], scale: 1, rotation: 0 },
            { class: "Crate", position: [1800, 0], scale: 1, rotation: -Math.PI / 2 },
            { class: "Crate", position: [1800, 138.6], scale: 1, rotation: -Math.PI / 2 },

            { class: "Beam", position: [1600, 227.9], scale: 2, rotation: 0 },

            { class: "Crate", position: [1400, 315.4], scale: 1, rotation: Math.PI / 2 },
            { class: "Crate", position: [1400, 454], scale: 1, rotation: Math.PI / 2 },
            { class: "Chest", position: [1600, 292.9], scale: 1, rotation: 0 },
            { class: "Crate", position: [1800, 315.4], scale: 1, rotation: -Math.PI / 2 },
            { class: "Crate", position: [1800, 454], scale: 1, rotation: -Math.PI / 2 },

            // { class: "Beam", position: [1600, 227.9], scale: 2, rotation: 0 },
        ]
    },

    // Office building
    {
        focus: [1600, 150, 600],
        entities: [
            { class: "Background", position: [1200, -60, -750], scale: 1, rotation: 0 },
            { class: "Slingshot", position: [300, 200, 0], scale: 1, rotation: 0 },
            { class: "Bubbles", position: [-1000, -275, 0], scale: 1, rotation: 0 },

            { class: "Crate", position: [1400, 0], scale: 1, rotation: Math.PI / 2 },
            { class: "Crate", position: [1400, 138.6], scale: 1, rotation: Math.PI / 2 },
            { class: "Chest", position: [1600, 0], scale: 1, rotation: 0 },
            { class: "Crate", position: [1800, 0], scale: 1, rotation: -Math.PI / 2 },
            { class: "Crate", position: [1800, 138.6], scale: 1, rotation: -Math.PI / 2 },

            { class: "Beam", position: [1600, 247.9], scale: 2, rotation: 0 },

            { class: "Chest", position: [1600, 332.9], scale: 1, rotation: 0 },
        ]
    },

    // Towers
    {
        focus: [1700, 150, 600],
        entities: [
            { class: "Background", position: [1200, -60, -750], scale: 1, rotation: 0 },
            { class: "Slingshot", position: [300, 200, 0], scale: 1, rotation: 0 },

            { class: "Bubbles", position: [-1000, -275, 0], scale: 1, rotation: 0 },
            
            { class: "Barrel", position: [1510, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1510, 135], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1510, 270], scale: 1, rotation: 0 },

            { class: "Chest", position: [1645, 0], scale: 1, rotation: 0 },

            { class: "Barrel", position: [1780, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1780, 135], scale: 1, rotation: 0 },

            { class: "Chest", position: [1915, 0], scale: 1, rotation: 0 },

            { class: "Barrel", position: [2050, 0], scale: 1, rotation: 0 },
            
        ]
    },

    // Horse
    {
        focus: [1700, 150, 600],
        entities: [
            { class: "Background", position: [1200, -60, -750], scale: 1, rotation: 0 },
            { class: "Slingshot", position: [300, 200, 0], scale: 1, rotation: 0 },

            { class: "Bubbles", position: [-1000, -275, 0], scale: 1, rotation: 0 },

            { class: "Kelp", position: [400, -100, -450], scale: 2, rotation: 0.1 },
            { class: "Kelp", position: [625, -100, -250], scale: 2, rotation: 0 },
            { class: "Kelp", position: [500, -100, -650], scale: 2.5, rotation: 0.2 },
            { class: "Kelp", position: [1225, -100, -350], scale: 1, rotation: 0 },

            { class: "Barrel", position: [1600, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1782, 0], scale: 1, rotation: 0 },
            { class: "Barrel", position: [1964, 0], scale: 1, rotation: 0 },

            { class: "Beam", position: [1670, 100], scale: 1, rotation: 0 },
            { class: "Beam", position: [1895, 100], scale: 1, rotation: 0 },

            { class: "Barrel", position: [1630, 140], scale: 1, rotation: 0 },
            { class: "Chest", position: [1882, 140], scale: 1, rotation: 0 },

            { class: "Beam", position: [1630, 240], scale: 1, rotation: 0 },
            
            { class: "Crate", position: [1670, 260], scale: 1, rotation: 0 }
        ]
    },
]